import ClientsTable from "./clients-table";

export default ClientsTable;
